/** Hooks */
Vue.component(/* webpackPrefetch: false */ 'add-to-cart-hook', () =>
    import('./components/Hooks/AddToCartHook' /* webpackChunkName: "js/add-to-cart-hook" */)
);
Vue.component(/* webpackPrefetch: false */ 'email-captured-hook', () =>
    import('./components/Hooks/EmailCapturedHook' /* webpackChunkName: "js/email-captured-hook" */)
);

/** Loading */
Vue.component(/* webpackPrefetch: false */ 'loading', () =>
    import('./components/Loading/Loading' /* webpackChunkName: "js/loading" */)
);
Vue.component(/* webpackPrefetch: false */ 'three-balls', () =>
    import('./components/Loading/ThreeBalls' /* webpackChunkName: "js/three-balls" */)
);

/** Misc */
Vue.component(/* webpackPrefetch: true */ 'accordion', () =>
    import('./components/Accordion' /* webpackChunkName: "js/accordion" */)
);
Vue.component('carousel', () =>
    import('./components/Carousel/Carousel' /* webpackChunkName: "js/carousel" */)
);
Vue.component(/* webpackPreload: true */ 'footer-email-capture', () =>
    import('./components/FooterEmailCapture' /* webpackChunkName: "js/footer-email-capture" */)
);
Vue.component(/* webpackPrefetch: true */ 'klarna-pay-as-low-as', () =>
    import('./components/KlarnaPayAsLowAs' /* webpackChunkName: "js/klarna-pay-as-low-as" */)
);
Vue.component(/* webpackPrefetch: true */ 'product-card', () =>
    import('./components/ProductCard' /* webpackChunkName: "js/product-card" */)
);
Vue.component(/* webpackPrefetch: false */ 'swatch-kit-order-form', () =>
    import('./components/SwatchKitOrderForm' /* webpackChunkName: "js/swatch-kit-order-form" */)
);
